import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateModeFooter from './EstimateModeFooter';
import setOrigin from '../../actions/setOrigin';

const mapStateToProps = (props) => {
  const { originReducer } = props;
  const originMODE = originReducer.mode;

  return {
    originMODE,
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators(
    {
      setOrigin,
    },
    dispatch,
  );

  return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstimateModeFooter);
